import React from "react";
import preloader from './preloader.svg'
import style from './Preloader.module.scss';

const Preloader = () => {
  return (
    <div className={style.wrap}><img src={preloader} alt='Preloader'></img></div>
  )
}

export default Preloader;